export const gAnalyticsKey = 'UA-86567001-2';